import { DocumentMagnifyingGlassIcon } from '@heroicons/react/24/outline';
import { useRouter } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { useSessionStore } from '@/entities/session/model/sessionStore';
import { useDocumentTitle } from '@/shared/hooks/useDocumentTitle';
import { cn } from '@/shared/lib/utils';
import { Button, Card, Text } from '@/shared/ui';

/**
 * 404 Not Found ページコンポーネント
 *
 * Pages層の責務:
 * - 404エラー（ページが見つからない）の画面表示
 * - ユーザーフレンドリーなエラーメッセージ
 * - 前のページに戻る／トップページへのナビゲーション
 *
 * notFoundComponent としても使用されるため、useNavigate ではなく
 * useRouter().navigate を使用してルートコンテキストに依存しないナビゲーションを行う
 */
export const NotFoundPage = () => {
  const { t } = useTranslation();
  const router = useRouter();
  const isAuthenticated = useSessionStore((s) => s.isAuthenticated);
  useDocumentTitle(t('errors.documentTitle.404'));

  return (
    <div
      className={cn('flex items-center justify-center', isAuthenticated ? 'h-[600px]' : 'h-screen')}
    >
      <Card className="flex w-full max-w-md flex-col items-center justify-center gap-4 p-6">
        <div className="flex items-center gap-2">
          <DocumentMagnifyingGlassIcon className="h-12 w-12 text-primary" />
          <Text variant="h1">{t('errors.404.title')}</Text>
        </div>
        <Text variant="body">
          {t('errors.404.message')}
          <br />
          {t('errors.404.message-detail')}
        </Text>

        <Button className="w-full sm:w-auto" onClick={() => router.navigate({ to: '/home' })}>
          {t('common.actions.go-to-top')}
        </Button>
      </Card>
    </div>
  );
};
